/* Blitzangebot — обратно броене по серверното време. Един скрипт за всички стикери на страницата. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function arm() {
    var nodes = document.querySelectorAll('.blitz-deal[data-blitz-end]:not([data-armed])');
    if (!nodes.length) return;
    var clientNow = Math.floor(Date.now() / 1000);
    nodes.forEach(function (el) {
      el.setAttribute('data-armed', '1');
      var end = parseInt(el.getAttribute('data-blitz-end'), 10);
      var serverNow = parseInt(el.getAttribute('data-now'), 10) || clientNow;
      var offset = serverNow - clientNow;            // колко „бърка" часовникът на клиента
      var h = el.querySelector('[data-blitz-h]'), m = el.querySelector('[data-blitz-m]'), s = el.querySelector('[data-blitz-s]');
      function tick() {
        var left = end - (Math.floor(Date.now() / 1000) + offset);
        if (left <= 0) {
          el.classList.add('is-over');
          clearInterval(timer);
          if (el.getAttribute('data-reload') === '1') setTimeout(function () { location.reload(); }, 1500);
          return;
        }
        if (h) h.textContent = pad(Math.floor(left / 3600));
        if (m) m.textContent = pad(Math.floor((left % 3600) / 60));
        if (s) s.textContent = pad(left % 60);
        if (left < 600) el.classList.add('is-urgent');
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  // Продукти, дошли по-късно (ajax списъци, бърз преглед)
  new MutationObserver(function () { arm(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
